<template>
  <CardDocument
    class="Contract"
    :data-cy="contractCy"
    :document="contract"
    :title="getContractTypeLabel(contract.type)">
    <div slot="status">
      <Set v-if="contract.signedAt" class="lg success" name="Pasirašyta">
        {{ contract.signedAt | date }}
      </Set>
      <Set v-else-if="contract.cancelledAt" class="lg danger" name="Būsena">
        Atšaukta
      </Set>
      <Set v-else class="lg danger" name="Būsena">
        Nepasirašyta
      </Set>
      <Btn
        v-if="!contract.signedAt && !contract.cancelledAt && hasManualSigning"
        class="buttonSign success sm"
        data-cy="sign"
        :isLoading="isSigning"
        @click="
          PROMPT({
            confirm: sign,
            text: 'Ar tikrai norite pasirašyti šią sutartį?',
          })
        ">
        Pasirašyti
      </Btn>
      <template v-if="hasUnsignedAmendment">
        <Set class="lg warning" data-cy="unsignedAmendment" name="Priedas">
          Nepasirašytas sutarties priedas
        </Set>
        <Row data-cy="amendment">
          <Column :md="6">
            <Btn
              v-if="lastAmendment.fileId"
              class="info sm"
              data-cy="download"
              @click="DOWNLOAD_FILE({ id: lastAmendment.fileId })">
              Peržiūrėti priedą
            </Btn>
          </Column>
          <Column :md="6">
            <Btn
              class="success sm"
              data-cy="signAmendment"
              :isLoading="isSigningAmendment"
              @click="
                PROMPT({
                  confirm: signAmendment,
                  text: 'Ar norite pasirašyti šį sutarties priedą?',
                })
              ">
              Pasirašyti priedą
            </Btn>
          </Column>
        </Row>
      </template>
    </div>
  </CardDocument>
</template>

<script>
import { actions, camelCase, getters } from '@/views/utils'
import CardDocument from './CardDocument'
import Seen from '../mixins/Seen'
import Set from './Set'

export default {
  mixins: [Seen('contract', 'CONTRACT', true, 2000)],
  components: { CardDocument, Set },
  props: {
    contract: Object,
    project: Object,
    reservation: Object,
  },
  data() {
    return {
      isSigning: false,
      isSigningAmendment: false,
    }
  },
  computed: {
    contractCy() {
      const { type, signedAt } = this.contract
      const transformedType = camelCase(type)
      return `contract${transformedType}${signedAt ? 'Signed' : ''}`
    },
    hasManualSigning() {
      return this.doesStepBranchSupportManualSigning(this.project.stepBranch)
    },
    lastAmendment() {
      const { amendments } = this.contract
      return amendments && amendments.length
        ? amendments[amendments.length - 1]
        : null
    },
    hasUnsignedAmendment() {
      return !!(this.lastAmendment && !this.lastAmendment.signedAt)
    },
    ...getters('getContractTypeLabel', 'doesStepBranchSupportManualSigning'),
  },
  methods: {
    async sign() {
      await this.$wrap(
        this.PATCH_CONTRACT({
          id: this.contract.id,
          signedAt: new Date(),
        }),
        'isSigning',
        'Sutartis pasirašyta',
      )
    },
    async signAmendment() {
      await this.$wrap(
        this.PATCH_CONTRACT({
          id: this.contract.id,
          $signAmendmentIndex: this.contract.amendments.length - 1,
        }),
        'isSigningAmendment',
        'Sutarties priedas pasirašytas',
      )
    },
    ...actions('DOWNLOAD_FILE', 'PATCH_CONTRACT', 'PROMPT'),
  },
}
</script>

<style lang="scss">
.Contract {
  padding: 1rem 2rem;

  .buttonSign {
    margin: 0.5rem 0;
  }
}
</style>
